import BlogCloudservice from './BlogCloudservice';
export default BlogCloudservice;
